import { Color24, Colors24 } from '@grammarly/badger-ui'

interface WebinarProps {
  color?: Color24
}

export const CaseStudyIcon = (props: WebinarProps) => {
  const { color = 'green60' } = props
  const strokeColor = Colors24[color]
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 14.2H15.5M9.5 11.4H15.5M9.5 8.6H15.5M9.5 5.8H12.5M6.5 12.8V15.75C6.5 16.4404 7.05964 17 7.75 17H17.25C17.9404 17 18.5 16.4404 18.5 15.75V4.25C18.5 3.55964 17.9404 3 17.25 3H7.75C7.05964 3 6.5 3.55964 6.5 4.25V4.4"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 13L3.33333 10.6667M2.55556 8.72222C2.55556 10.2257 3.77434 11.4444 5.27778 11.4444C6.78122 11.4444 8 10.2257 8 8.72222C8 7.21878 6.78122 6 5.27778 6C3.77434 6 2.55556 7.21878 2.55556 8.72222Z"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
